import React, { FC } from 'react';
import styled from 'styled-components';
import {
  fontFamily,
  fontWeight,
  textAlign,
  lineHeight,
  letterSpacing,
  FontFamilyProps,
  FontWeightProps,
  LineHeightProps,
  LetterSpacingProps,
  FontSizeProps,
} from 'styled-system';
import { base, themed } from '../base';

type Props = {
  content?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  mt?: string | number | string[] | number[];
  mb?: string | number | string[] | number[];
  textAlign?: string;
};

type FinalType = FontFamilyProps &
  FontWeightProps &
  LineHeightProps &
  FontSizeProps &
  LetterSpacingProps;

const HeadingWrapper = styled.p<FinalType>(
  base,
  fontFamily,
  fontWeight,
  textAlign,
  lineHeight,
  letterSpacing,
  themed('Heading')
);

const Heading: FC<FinalType & Props> = ({
  content,
  as = 'h2',
  mt = 0,
  mb = '1rem',
  fontWeight = 'bold',
  ...props
}) => (
  <HeadingWrapper {...props} {...{ as, mt, mb, fontWeight }}>
    {content}
  </HeadingWrapper>
);

export default Heading;
